var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.8974 0H0V85.8974H85.8974V0Z",
    fill: "#FAD40A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.893 70.8456V59.6943H58.201V70.8456H53V46H58.201V55.3553H67.893V46H73.131V70.8456H67.893Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.205251
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1876 48.1384C57.9126 49.5608 57.4774 50.8457 56.8781 51.993C56.2788 53.1404 55.5234 54.1256 54.6142 54.9486C53.7029 55.7717 52.6499 56.408 51.4513 56.8575C50.2547 57.307 48.9308 57.5307 47.4858 57.5307C45.8643 57.5307 44.3475 57.2557 42.9395 56.7076C41.5295 56.1596 40.3144 55.3366 39.2922 54.2385C38.2701 53.1404 37.4655 51.7878 36.8785 50.1786C36.2915 48.5694 36 46.6935 36 44.5465C36 42.4509 36.2668 40.5606 36.8046 38.8775C37.3403 37.1945 38.1079 35.7721 39.1054 34.6124C40.103 33.4527 41.3201 32.562 42.7548 31.9359C44.1895 31.312 45.7905 31 47.5638 31C49.1094 31 50.5133 31.2299 51.7735 31.6917C53.0337 32.1535 54.1195 32.7898 55.0288 33.6005C55.9401 34.4113 56.6626 35.3657 57.1983 36.4638C57.734 37.5619 58.0644 38.7338 58.1896 39.9818H52.9886C52.6397 38.5594 51.9664 37.4572 50.9669 36.6711C49.9694 35.885 48.8466 35.4929 47.5987 35.4929C45.4292 35.4929 43.8324 36.2729 42.8082 37.8307C41.786 39.3906 41.2749 41.5294 41.2749 44.2489C41.2749 47.0178 41.7799 49.1688 42.7897 50.7041C43.7995 52.2373 45.3163 53.0049 47.336 53.0049C48.8815 53.0049 50.1233 52.5883 51.0592 51.7508C51.9952 50.9155 52.6356 49.7106 52.9865 48.1405H58.1876V48.1384Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.205251
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6815 39.8456L27.8269 23.6821L23.8984 39.8456H19.0339L12 15H17.5377L21.616 31.0896L25.058 15H30.5218L34.3005 31.0896L38.3419 15H43.6558L36.6958 39.8456H31.6815Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.205251
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d57bc450.svg";
export { ForwardRef as ReactComponent };